import { UserOverview } from "api/generated/model";
import { useOrgUserProfileCookie } from "utils/profileCookie";

export function useCurrentUserOverview(): UserOverview | undefined {
    const user = useOrgUserProfileCookie();
    if (!user) {
        return undefined;
    }
    return {
        id: user.userId,
        firstname: user.firstName,
        lastname: user.lastName,
        email: user.email,
    };
}
